import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIntegrationIconUnselected = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M27 21V27H14.5H2V9.5V7H12L14.5 10.75H15.5",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.4891 15.3505L24.9025 15.3759L27.316 15.4013L19.5698 22.6995L11.9791 15.2398L17.3672 15.2965",
			stroke: "currentColor",
			strokeWidth: 1.41145
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6938 15.7814C16.7106 14.1879 17.0411 12.6133 17.6664 11.1475C18.2917 9.68176 19.1996 8.35349 20.3382 7.23859C21.4769 6.12368 22.824 5.24396 24.3026 4.64965C25.7812 4.05535 27.3624 3.7581 28.9559 3.77488L28.8879 10.2307C28.1422 10.2228 27.4023 10.3619 26.7103 10.6401C26.0184 10.9182 25.388 11.3299 24.8551 11.8516C24.3223 12.3733 23.8974 12.9949 23.6048 13.6809C23.3121 14.3668 23.1575 15.1037 23.1496 15.8494",
			stroke: "currentColor",
			strokeWidth: 1.41145
		})
	]
});
export default SvgIntegrationIconUnselected;
